<template>
    <div style="margin-left: 75px;">
        <!-- site dialog -->
        <d-site
            v-if     = "items"
            v-model  = "showSite"
            :site-id = "siteId"
        />
        <!-- site dialog -->

        <d-contract-zus-edit
            v-if         = "zus"
            v-model      = "create"
            :contract-id = "-1"
            :company-id  = "zus.id"
            @saved       = "onContractSaved"
        />

        <company-app-bar
            title       = "ZÜS"
            :categories = "['zus']"
            @search       = "onSearch"
        />

        <div class="v-flex">
            <c-index
                :items="items"
                :enable-search="false"
                :criterion="criteria"
                :filter="indexFilter"
                :miminize      = "false"
                @clear-filter = "onClearFilter"
                @selected="onZus"
                style="position: relative; margin-right: 75px;"
            >
                <template v-slot:item="{ item }">
                    <div>
                        {{ item.name }}
                    </div>
                    <v-spacer></v-spacer>
                    <company-roles
                        :ignore="5"
                        :item="item"
                    />
                </template>
                <template v-slot:detail="{ item }" >
                    <div v-if="item" class="mt-1 h-100" style="width: calc(100% + 12px);">
                        <v-row class="no-frame pl-4 h-100">
                            <v-col class="no-frame col-4 h-100 pr-1">
                                <c-servicepartner-edit
                                    v-if     = "zus"
                                    :company = "zus"
                                    style    = "margin-top: 9px;"
                                />

                                <service-customer-list
                                    style    = "margin-top: 14px; height: calc(100% - 570px);"
                                    v-if     = "zus"
                                    @customer="onCompanyCustomer"
                                    ref      = "customerList"
                                />
                            </v-col>

                            <v-col
                                class  = "no-frame pl-2 pr-0 col-4"
                                :class = "item.show ? 'pl-4' : 'pl-0'"
                            >
                                <c-flip-card
                                    v-model="flip"
                                    color="white--text" :top="17" :right="90"
                                >
                                    <template v-slot:front>
                                        <v-card-iterator
                                            label          = "Verträge"
                                            v-if           = "contracts.items"
                                            :items         = "contracts.items"
                                            :columns       = "1"
                                            :item-height   = "109"
                                            :filter-height = "150"
                                            :enable-search = "true"
                                            :filter        = "textfilter"
                                            class          = "w-100"
                                            ref            = "iterator"
                                        >
                                            <template v-slot:toolbar>
                                                <div class="v-flex">
                                                    <c-header-button label="ZÜS" @click = "onZusCreate" :tooltip="$t('contract.create.zus')" />
                                                </div>
                                            </template>
                                            <template v-slot:filter>
                                                <c-contract-zus-card-filter
                                                    v-model = "filter"
                                                    @input  = "onFilterChanged"
                                                    class   = "mt-1 mb-n1"
                                                />
                                            </template>
                                            <template v-slot:card="{ item }">
                                                <c-contract-zus-card
                                                    :contract   = "item"
                                                    :background = "background(contracts.selected, item)"
                                                    @saved      = "onContractSaved(item)"
                                                    @selected   = "onContractSelected(item)"
                                                />
                                            </template>
                                        </v-card-iterator>

                                    </template>
                                    <template v-slot:back>
                                        <contact-card-iterator
                                            :items       = "contacts.items"
                                            :company-id  = "zus ? zus.id : null"
                                            :contract-id = "contracts.selected"
                                            :customer-id = "customer.detail ? customer.detail.id : null"
                                            :combine-allowed = "true"
                                            @selected    = "onContactSelected"
                                            @zoom        = "contacts.zoom = true"
                                            class        = "w-100"
                                        />
                                    </template>
                                </c-flip-card>
                            </v-col>

                            <v-col class="no-frame pl-2 col-4" :class="item.show ? 'col-4' : 'col-3'">
                                <c-site-card-iterator
                                    v-if      = "zus"
                                    role      = "ZUS"
                                    :customer = "customer.detail"
                                    :contract = "contracts.selected"
                                    :contact  = "contacts.selected"
                                    :contract-height = "150"
                                    class     = "w-100"
                                    @site     = "onSite"
                                    ref       = "siteIterator"
                                >
                                    <template v-slot:editor="{ site }">
                                        <c-contract-zus-editor
                                            :unit = "site"
                                        />
                                    </template>
                                </c-site-card-iterator>
                            </v-col>
                        </v-row>
                    </div>
                </template>

            </c-index>
        </div>
    </div>
</template>

<script>

import Core                   from "@/modules/core/service/Core";
import CIndex                 from "@/modules/core/components/utils/CIndex";
import CSiteCardIterator      from "@/modules/msd/unit/components/controlls/CSiteCardIterator";
import CContractZusCard       from "@/modules/msd/company/contract/components/controls/zus/CContractZusCard";
import CompanyRoles           from "@/modules/msd/company/common/components/controlls/CompanyRoles";
import Company                from "@/modules/msd/company/common/service/Company";
import Contract               from "@/modules/msd/company/contract/service/Contract";
import DSite                  from "@/modules/msd/unit/components/dialog/DSite";
import ContactCardIterator    from "@/modules/msd/company/contact/components/controlls/CContactCardIterator";
import CompanyAppBar          from "@/modules/msd/company/common/components/nav/CompanyAppBar";
import CServicepartnerEdit    from "@/modules/msd/company/servicepartner/components/controlls/CServicepartnerEdit";
import ServiceCustomerList    from "@/modules/msd/company/servicepartner/components/controlls/ServiceCustomerList";
import CFlipCard              from "@/modules/core/components/utils/CFlipCard";
import CContractZusCardFilter from "@/modules/msd/company/contract/components/controls/zus/CContractZusCardFilter";
import CHeaderButton          from "@/modules/core/components/utils/CHeaderButton";
import DContractZusEdit       from "@/modules/msd/company/contract/components/controls/zus/DContractZusEdit";
import CContractZusEditor from "@/modules/msd/company/contract/components/controls/zus/CContractZusEditor.vue";
import VCardIterator from "@/modules/core/components/utils/VCardIterator.vue";

const config = {
    roles: ["ZUS"],
}

export default {
    name: "MInspection",
    components: {
        VCardIterator,
        CContractZusEditor,
        DContractZusEdit,
        CHeaderButton,
        CContractZusCardFilter,
        CFlipCard,
        ServiceCustomerList,
        CServicepartnerEdit,
        CompanyAppBar,
        ContactCardIterator,
        DSite,
        CompanyRoles,
        CContractZusCard,
        CSiteCardIterator,
        CIndex
    },

    data: () => ({
        create    : false,
        showSite  : false,
        siteId    : null,
        criteria: null,
        items: null,
        zus: null,
        flip: false,

        customer: {
            index: null,
            detail: null
        },

        filter  : {
            types   : [ "ZUS" ],
            active  : true,
            inactive: false,
            customer: null,
            role    : 1
        },

        contracts: {
            items: null,
            selected    : null,
            filter: {
                types   : ["ZUS" ],
                active      : true,
                inactive    : false,
                role    : 1
            }
        },
        contacts: {
            selected    : null,
            editselected: null,
            zoom    : false,
            edit    : false,
            items   : null,
            filter  : {}
        }
    }),

    mounted() {
        Core.init.load(this.$store, false).then(() => {
            this.load();
        })
    },

    methods: {
        load() {
            Company.index(null, config.roles,false,(data) => {
                this.items = data;
            })
        },

        loadCompany () {
            Company.get(this.zus.id).then ((data) => {
                this.zus = data;
            });

            Company.contacts(this.zus.id, this.contacts.filter,(data) => {
                this.contacts.items = data;
            });

            Contract.list(this.zus.id, this.createContractFilter(),(data) => {
                this.contracts.items = data;
            });
        },

        onFilterChanged(filter) {
            this.contracts.filter = filter;
            Contract.list(this.zus.id, this.createContractFilter(), (data) => {
                this.contracts.items = data;
            });
        },


        onZus (item) {
            this.$store.dispatch("setTitle", item.name);
            this.zus = item;
            this.loadCompany();
        },

        onCompanyCustomer(customer) {
            this.customer.detail = customer;
            this.contacts.filter.customer = null; //this.customer.detail;
            this.contracts.selected = null;
            this.contacts.selected = null;

            if (!customer) {
                this.contracts.items = null;
                this.contacts.items = null;
            }

            this.loadCompany();
        },

        onSearch(criteria) {
            this.criteria = criteria;
        },

        onClearFilter () {
            this.criteria = null;
        },

        onSite (site) {
            this.showSite = true;
            this.siteId = site.id;
        },

        onZusCreate () {
            console.log("onZusCreate")
            this.create = true;
        },

        onContractSaved (contract) {
            this.$refs.iterator.refresh(contract);
        },

        onContractSelected (contract) {
            this.$refs.siteIterator.onEndAssingMode();
            this.contacts.selected = null;
            if (this.contracts.selected && this.contracts.selected.id === contract.id) {
                this.contracts.selected = null;
            } else {
                this.contracts.selected = contract;
            }
        },

        onContactSelected (contact) {
            this.$refs.siteIterator.onEndAssingMode();
            this.contracts.selected = null;
            this.contacts.selected = contact;
        },

        indexFilter (item, search) {
            if (!search || item.name.includes (search)) {
                return true;
            }

            return false;
        },

        createContractFilter() {
            this.contracts.filter.customer = this.customer.detail ? this.customer.detail.id : null;
            return this.contracts.filter;
        },

        getFilter (zus) {
            return {
                customer: null,
                contact : this.contacts.selected  ? this.contacts.selected.id : null,
                contract: this.contracts.selected ? this.contracts.selected.id : null,
                company : zus ? zus.id : null,
            };
        },

        background (selected, contract) {
            if (selected && selected.id === contract.id) {
                return "background-selected"
            }
        },

        textfilter (item, search) {
            if (!search) {
                return true;
            }

            if (this.includes(item.id.toString(), search)) {
                return true;
            }

            if (this.includes(item.customer.name, search)) {
                return true;
            }

            return false;
        },

        includes (text, search) {
            if (!text) {
                return false;
            }

            return text.toUpperCase().includes(search.toUpperCase())
        }
    }
}
</script>

<style scoped>

</style>